//---SIDE NAV MENU
export function openNav() {
	document.getElementById("side-nav-menu").style.display = "block";
  }
  
export function closeNav() {
	document.getElementById("side-nav-menu").style.display = "none";
	document.body.style.backgroundColor = "";
  }
